'use strict';

exports.__esModule = true;

var _ref;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TimelineItem = function (_Component) {
  _inherits(TimelineItem, _Component);

  function TimelineItem() {
    var _temp, _this, _ret;

    _classCallCheck(this, TimelineItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      dragStartDate: null,
      dragEndDate: null // getTimelinePosition() {
      //   const {
      //     getTimelinePosition,
      //   } = this.props;
      //   return getTimelinePosition();
      // }

    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  TimelineItem.prototype.getItem = function getItem() {
    return this.props.item;
  };

  TimelineItem.prototype.getCursorPositionLeft = function getCursorPositionLeft(x) {
    var getCursorPositionLeft = this.props.getCursorPositionLeft;
    return getCursorPositionLeft(x);
  };

  TimelineItem.prototype.getTimeline = function getTimeline() {
    var getTimeline = this.props.getTimeline;
    return getTimeline();
  };

  TimelineItem.prototype.getTimelinePosition = function getTimelinePosition(startDate) {
    // let {
    //   minDate,
    //   maxDate,
    // } = this.getItem();
    var _props = this.props,
        minDate = _props.minDate,
        maxDate = _props.maxDate; // minDate = moment(minDate);
    // maxDate = moment(maxDate);

    var min = minDate.toDate().getTime();
    var max = maxDate.toDate().getTime();
    var current = startDate.toDate().getTime(); // console.log("_getAvailableYearsHtml min max current", min, max, current);

    var percent = (max - min) / 100; // console.log("_getAvailableYearsHtml percent", percent);

    var startOffset = (current - min) / percent; // console.log("_getAvailableYearsHtml startOffset", startOffset);

    return startOffset;
  };

  TimelineItem.prototype.onTimelineMouseDown = function onTimelineMouseDown(event, direction) {
    var _this2 = this,
        _setState;

    var _state$direction = this.state[direction],
        currentPosition = _state$direction === undefined ? null : _state$direction;

    if (currentPosition !== null) {
      return;
    }

    var clientX = event.clientX;
    var newX = this.getCursorPositionLeft(clientX); // const onMouseUp = event => this.onTimelineMouseUp(event);

    var onMouseMove = function onMouseMove(event) {
      return _this2.onTimelineMouseMove(event, direction);
    };

    this.setState((_setState = {}, _setState[direction] = newX, _setState), function () {
      // onMouseUp={event => this.onTimelineMouseUp(event)}
      // onMouseOut={event => this.onTimelineMouseOut(event)}
      // onMouseMove={event => this.onTimelineMouseMove(event)}
      var _global = global,
          window = _global.window;
      window.addEventListener("mousemove", onMouseMove);
      window.addEventListener("mouseup", function (event) {
        var _this2$setState;

        _this2.onTimelineMouseUp(event, direction);

        _this2.setState((_this2$setState = {}, _this2$setState[direction] = null, _this2$setState));

        window.removeEventListener("mousemove", onMouseMove);
      });
    });
  };

  TimelineItem.prototype.onTimelineMouseMove = function onTimelineMouseMove(event, direction) {
    var _setState2;

    var clientX = event.clientX;
    var dragDate = this.state[direction];

    if (!dragDate) {
      return;
    }

    var newX = this.getCursorPositionLeft(clientX);
    this.setState((_setState2 = {}, _setState2[direction] = newX, _setState2));
  };

  TimelineItem.prototype.onTimelineMouseUp = function onTimelineMouseUp(event, direction) {
    var clientX = event.clientX;
    var _state$direction2 = this.state[direction],
        dragDate = _state$direction2 === undefined ? null : _state$direction2;

    if (dragDate === null) {
      return;
    }

    var newX = this.getCursorPositionLeft(clientX); // getBoundingClientRect

    this.onChange(newX, direction);
  };
  /**
   * Обновление выполняется как стартовой точки, так и конечной
   */


  TimelineItem.prototype.onChange = function onChange(clientX, direction) {
    var _props2 = this.props,
        minDate = _props2.minDate,
        maxDate = _props2.maxDate,
        onStartDateChange = _props2.onStartDateChange,
        onEndDateChange = _props2.onEndDateChange;

    var _getItem = this.getItem(),
        startDate = _getItem.startDate,
        endDate = _getItem.endDate;

    var timeline = this.getTimeline();

    if (!timeline) {
      return;
    }

    minDate = (0, _moment2.default)(minDate);
    maxDate = (0, _moment2.default)(maxDate);
    startDate = (0, _moment2.default)(startDate);
    endDate = (0, _moment2.default)(endDate);
    var offsetWidth = timeline.offsetWidth;
    var offset = 100 - (offsetWidth - clientX) / (offsetWidth / 100); // console.log("onChange offset", offset);
    // console.log("onChange minDate", minDate);
    // console.log("onChange maxDate", maxDate);

    var startTime = minDate.toDate().getTime();
    var endTime = maxDate.toDate().getTime();
    var newTime = startTime + (endTime - startTime) * (offset / 100); // console.log("onChange newTime", endTime, startTime, offset, (endTime - startTime), newTime);

    if (direction === "dragStartDate") {
      onStartDateChange(newTime);

      if (newTime > endDate.toDate().getTime()) {
        onEndDateChange(newTime);
      }
    } else {
      onEndDateChange(newTime);

      if (newTime < startDate.toDate().getTime()) {
        onStartDateChange(newTime);
      }
    }
  }; // onTimelineMouseOut(event) {
  //   // const {
  //   //   clientX,
  //   // } = event;
  //   // this.setState({
  //   //   dragStartDate: null,
  //   // });
  //   // console.log("onTimelineMouseOut", event, { ...event }, clientX);
  // }


  TimelineItem.prototype.render = function render() {
    var _this3 = this;

    var _props3 = this.props,
        item = _props3.item,
        classes = _props3.classes,
        getTimelinePosition = _props3.getTimelinePosition,
        style = _props3.style,
        minDate = _props3.minDate,
        maxDate = _props3.maxDate,
        getTimeline = _props3.getTimeline,
        getCursorPositionLeft = _props3.getCursorPositionLeft,
        onStartDateChange = _props3.onStartDateChange,
        onEndDateChange = _props3.onEndDateChange,
        editable = _props3.editable,
        other = _objectWithoutProperties(_props3, ['item', 'classes', 'getTimelinePosition', 'style', 'minDate', 'maxDate', 'getTimeline', 'getCursorPositionLeft', 'onStartDateChange', 'onEndDateChange', 'editable']);

    var _state = this.state,
        _state$dragStartDate = _state.dragStartDate,
        dragStartDate = _state$dragStartDate === undefined ? null : _state$dragStartDate,
        _state$dragEndDate = _state.dragEndDate,
        dragEndDate = _state$dragEndDate === undefined ? null : _state$dragEndDate;
    var startDate = item.startDate,
        endDate = item.endDate,
        label = item.label;

    if (!startDate || !endDate) {
      return null;
    }

    startDate = (0, _moment2.default)(startDate);
    endDate = (0, _moment2.default)(endDate);
    var startDateOffset = this.getTimelinePosition(startDate) + '%';
    var endDateOffset = 100 - this.getTimelinePosition(endDate) + '%';
    /**
     * Учитываем позицию при перетаскивании
     */

    if (dragStartDate !== null) {
      startDateOffset = dragStartDate + 'px';
    }

    if (dragEndDate !== null) {
      endDateOffset = 'calc(100% - ' + dragEndDate + 'px)';
    }

    return _react2.default.createElement('div', _extends({
      // key={index}
      className: [classes.position, editable ? "editable" : ""].join(" "),
      style: _extends({
        left: startDateOffset,
        right: endDateOffset
      }, style)
    }, other), _react2.default.createElement('div', {
      className: [classes.control, editable ? "editable" : ""].join(" "),
      style: {
        left: 0
      },
      onMouseDown: editable ? function (event) {
        return _this3.onTimelineMouseDown(event, "dragStartDate");
      } : undefined
    }), _react2.default.createElement('div', {
      className: [classes.control, editable ? "editable" : ""].join(" "),
      style: {
        right: 0
      },
      onMouseDown: editable ? function (event) {
        return _this3.onTimelineMouseDown(event, "dragEndDate");
      } : undefined
    }), _react2.default.createElement('span', {
      className: classes.itemLabel
    }, label));
  };

  return TimelineItem;
}(_react.Component);

TimelineItem.propTypes = process.env.NODE_ENV !== "production" ? (_ref = {
  classes: _propTypes2.default.object.isRequired,
  item: _propTypes2.default.object.isRequired,
  editable: _propTypes2.default.bool.isRequired
}, _ref['editable'] = _propTypes2.default.bool.isRequired, _ref.minDate = _propTypes2.default.instanceOf(_moment2.default).isRequired, _ref.maxDate = _propTypes2.default.instanceOf(_moment2.default).isRequired, _ref.getTimeline = _propTypes2.default.func.isRequired, _ref.getCursorPositionLeft = _propTypes2.default.func.isRequired, _ref.onStartDateChange = _propTypes2.default.func.isRequired, _ref.onEndDateChange = _propTypes2.default.func.isRequired, _ref.label = _propTypes2.default.string, _ref) : {};
exports.default = TimelineItem;
module.exports = exports['default'];